import React from 'react';
import { useLocation } from 'react-router-dom';
import * as env from 'config/environment';

export const DevidendPremium = () => {
  const { pathname } = useLocation();
  const linkDo = `${env.premiumURL}?service=${
    env.serviceName
  }&utm_source=tw_minkabu&utm_medium=dividend&utm_campaign=dividend_202409&callback_url=${encodeURI(
    `${env.appURL}/auth?callbackPath=${pathname}`
  )}`;

  return (
    <>
      <div className="flex flex-col bg-teal-500" style={{ height: '380px' }}>
        <div className="mt-4 text-3.5xl text-white font-bold text-center">
          配当金<span className="text-2xl">を</span>
          <br />
          サクッ<span className="text-2xl">と</span>計算！
        </div>
        <div className="relative flex justify-center mt-1">
          <img
            src="/static/images/premium/dividend_image.png"
            alt=""
            width="300"
            height="400"
            className="absolute"
            style={{ top: '0%' }}
          />
        </div>
      </div>
      <div className="flex flex-col bg-white">
        <div className="flex flex-row items-end justify-center mt-14">
          <div className="mr-1 text-lg font-bold text-teal-500">
            こんな方におすすめ
          </div>
          <img src="/static/images/premium/denkyu.svg" alt="" />
        </div>
        <div className="flex flex-col items-center">
          <div className="text-base font-bold text-bluegray-700">
            <div className="flex flex-row mt-2">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">配当金の入金額を知りたい</div>
            </div>
            <div className="flex flex-row mt-2">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">配当予想を銘柄ごとに見たい</div>
            </div>
            <div className="flex flex-row mt-2">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">配当関連ニュースが知りたい</div>
            </div>
          </div>
        </div>
        <div className="flex flex-row items-start justify-center pt-4 pb-16 text-sm text-bluegray-500">
          <div>※</div>
          <div className="ml-2">
            配当金の入金額はSBI証券、楽天証券のみ
            <br />
            表示できます。
          </div>
        </div>
      </div>
      {/* PC */}
      <div
        className="lg:block hidden sticky w-full bg-white px-2 pb-2 shadow-fBtn"
        style={{ left: '0%', bottom: '0%' }}>
        <div className="flex flex-row pt-2 pb-1 justify-center text-sm font-bold app-primary-label-block">
          みんかぶプレミアム初回30日間無料
        </div>
        <div className="flex justify-center">
          <a href={linkDo} target="_self">
            <div className="max-w-full flex flex-col py-4 px-24 mx-auto justify-center text-lg font-bold text-center text-white bg-red-500 rounded-lg cursor-pointer hover:opacity-75">
              <div className="">あなたの配当金を見てみる</div>
            </div>
          </a>
        </div>
      </div>
      {/* SP */}
      <div
        className="lg:hidden block fixed w-full bg-white px-2 pb-2 shadow-fBtn"
        style={{ left: '0%', bottom: '0%' }}>
        <div className="flex flex-row pt-2 pb-1 justify-center text-sm font-bold app-primary-label-block">
          みんかぶプレミアム初回30日間無料
        </div>
        <a href={linkDo} target="_self">
          <div className="max-w-full flex flex-col py-4 items-center justify-center text-lg font-bold text-center text-white bg-red-500 rounded-lg cursor-pointer hover:opacity-75">
            <div className="">あなたの配当金を見てみる</div>
          </div>
        </a>
      </div>
    </>
  );
};
